import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import PatioDoorRepairServicesInChateauguay from "./sections/PatioDoorRepairServicesInChateauguay";
import ArtisanSanctuaries from "./sections/ArtisanSanctuaries";
import GenerationsOfFlavor from "./sections/GenerationsOfFlavor";
import ImpactStories from "./sections/ImpactStories";
import SecureYourCompanion from "./sections/SecureYourCompanion";
import TheViralityEngine from "./sections/TheViralityEngine";
import CicloDeAjudaMutua from "./sections/CicloDeAjudaMutua";
import TrendingLandscapingIdeas from "./sections/TrendingLandscapingIdeas";
import ServiceArea from "./sections/ServiceArea";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <PatioDoorRepairServicesInChateauguay />
      <ArtisanSanctuaries />
      <GenerationsOfFlavor />
      <ImpactStories />
      <SecureYourCompanion />
      <TheViralityEngine />
      <CicloDeAjudaMutua />
      <TrendingLandscapingIdeas />
      <ServiceArea />
      <Footer />
    </div>;
}